export default __webpack_public_path__ + "static/office_photo-min-612456650a12298dacfcb03e785d62ae.jpg";